import { Component, Input, OnInit } from "@angular/core";
import { QuestionEntity } from "src/app/models/new-product/base/question-entity.model";
import { ProposalConst } from "src/app/models/new-product/sme/mortgage-fire/singapore/base/mf-sg-proposal-constant";

@Component({
    selector: "text-area-question",
    templateUrl: "./text-area-question.component.html",
    styleUrls: ["./text-area-question.component.scss"],
    standalone: false
})
export class TextAreaQuestionComponent implements OnInit {
  noAnswerDefaultText = ProposalConst.noAnswerDefaultText;
  @Input() public question!: QuestionEntity;

  constructor() {}

  ngOnInit(): void {}
}
